import { State } from 'store';
import { AppState } from 'store/reducers';
import Web3 from 'web3';
import Web3Modal from 'web3modal';

import { createSelector } from '@reduxjs/toolkit';
import { NetworkParams } from '../../models';

const selectApp = (state: State): AppState => state.app;

export const selectWeb3 = createSelector(
  [selectApp],
  (appState: AppState): Web3 => appState.web3
);

export const selectWeb3Modal = createSelector(
  [selectApp],
  (appState: AppState): Web3Modal => appState.web3Modal
);

export const selectWeb3Provider = createSelector(
  [selectApp],
  (appState: AppState) => appState.web3Provider
);

export const selectGasPrice = createSelector(
  [selectApp],
  (appState: AppState): string => appState.gasPrice
);

export const selectInitializingFinished = createSelector(
  [selectApp],
  (state: AppState): boolean => state.initializingFinished
);

export const selectConnectedNetwork = createSelector(
  [selectApp],
  (appState: AppState): NetworkParams => appState.connectedNetwork
);

export const selectConnectedAddress = createSelector(
  [selectApp],
  (state: AppState): string => state.connectedAddress
);

export const selectShowLoader = createSelector(
  [selectApp],
  (state: AppState): boolean => state.showLoader
);
